import { render, staticRenderFns } from "./ClientServiceSpotForm.vue?vue&type=template&id=60e6127e"
import script from "./ClientServiceSpotForm.vue?vue&type=script&lang=js"
export * from "./ClientServiceSpotForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports